import React, { useRef, useState, useEffect, useMemo } from 'react';
import classnames from 'classnames';
import { trophicLevels } from 'constants/nodes';
import './NodePillNew.scss';
import Icon from './Icon';
import { usePlayModeState } from '../state/PlayModeState';

const NodePillNew = ({ node, lowOpacity, results, uniqueKey, isInput }) => {
  const icon = trophicLevels.filter(
    ({ name }) => name === node.trophicLevel
  )?.[0]?.iconNew;

  const nodePillWidth = useRef(null);

  const percentDiff = useMemo(() => {
    if (!results) return null;
    const exag = results?.abundanceExaggeration ?? 1;
    // Normalize each value independently: abundanceResult is exaggerated when
    // the node is currently fixed; originalAbundanceResult is exaggerated only
    // when the node was originally fixed in the matrix.
    const normalizedCurrent =
      results?.abundanceResult / (results?.fixed ? exag : 1);
    const normalizedOriginal =
      results?.originalAbundanceResult / (results?.originalFixed ? exag : 1);
    return Math.abs(normalizedOriginal - normalizedCurrent) * 100;
  }, [results]);

  const coloringClass = useMemo(() => {
    if (results?.fixed) return 'input';
    if (results?.abundanceResult > results?.originalAbundanceResult) {
      return 'positive';
    }
    if (results?.abundanceResult < results?.originalAbundanceResult) {
      return 'negative';
    }
    return null;
  }, [results]);

  const nodesAnimated = usePlayModeState(state => state.nodesAnimated);

  const animationCss = useMemo(() => {
    if (
      !nodePillWidth.current ||
      !percentDiff ||
      (!node.fixed && !nodesAnimated.includes(node.id))
    )
      return {
        width: 0,
        transitionDuration: 'unset',
      };
    const widthInPixels =
      nodePillWidth.current.getBoundingClientRect().width * (percentDiff / 100);

    const speed = 100; // px per second
    const duration = widthInPixels / speed; // seconds

    let cssProps = {
      width: `${percentDiff}%`,
    };

    // Separated transition props in case we need conditional later
    cssProps = {
      transitionProperty: 'width',
      transitionTimingFunction: 'linear',
      transitionDuration: `${duration}s`,
      ...cssProps,
    };

    return cssProps;
  }, [percentDiff, node, nodesAnimated]);

  return (
    <div
      xmlns="http://www.w3.org/1999/xhtml"
      className={classnames('NodePillNew', {
        'low-opacity': lowOpacity,
        isInput,
      })}
      ref={nodePillWidth}
    >
      <div
        className={classnames('results-bar', coloringClass)}
        style={animationCss}
      ></div>
      <Icon icon={icon} className="NodePillNew-icon" />
      <div className="NodePillNew-name">{node.name}</div>
    </div>
  );
};
export default NodePillNew;
